<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Conciliación Regio Ruta</v-toolbar-title>
          <v-spacer />
          <v-btn
            small
            text
            :loading="loadingPdf"
            :disabled="!grupos.length"
            @click="exportarPdf"
          >
            Descargar PDF
            <v-icon right>mdi-file-pdf-box</v-icon>
          </v-btn>
          <v-btn
            small
            text
            :loading="loadingExport"
            :disabled="!grupos.length"
            @click="exportarCsv"
          >
            Descargar CSV
            <v-icon right>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row no-gutters class="pb-4" style="justify-content: space-between">
            <v-col sm="10" style="align-self: center">
              <v-row>
                <v-col cols="2" class="d-flex align-end">
                  <v-autocomplete
                    v-model="selectedClienteId"
                    :items="clientItem"
                    item-text="text"
                    item-value="value"
                    label="Cliente"
                    dense
                    clearable
                    prepend-inner-icon="mdi-account-multiple"
                    :loading="loadingClients"
                    hide-details
                    class="mt-1"
                  />
                </v-col>

                <v-col cols="3" class="d-flex align-end">
                  <v-autocomplete
                    v-model="selectedRamalIds"
                    :items="ramalItems"
                    item-text="text"
                    item-value="value"
                    label="Ramal (opcional)"
                    dense
                    clearable
                    multiple
                    chips
                    small-chips
                    prepend-inner-icon="mdi-sign-direction"
                    :disabled="!Number.isFinite(idclienteEff)"
                    :loading="loadingRamales"
                    hide-details
                    class="mt-1"
                    no-data-text="Selecciona un cliente"
                  />
                </v-col>

                <v-col cols="2" class="d-flex align-end">
                  <v-dialog
                    ref="dialogIni"
                    v-model="ui.modalIni"
                    :return-value.sync="filtros.fecha_inicio"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="formatFechaDisplay(filtros.fecha_inicio)"
                        dense
                        label="Fecha inicio"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="ui.tmpIni"
                      scrollable
                      locale="es"
                      :min="fechaMinReporte"
                      :max="fechaMaxReporte"
                    >
                      <v-spacer />
                      <v-btn text @click="ui.modalIni = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="acceptFechaInicio">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="2" class="d-flex align-end">
                  <v-dialog
                    ref="dialogFin"
                    v-model="ui.modalFin"
                    :return-value.sync="filtros.fecha_fin"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="formatFechaDisplay(filtros.fecha_fin)"
                        dense
                        label="Fecha fin"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="ui.tmpFin"
                      scrollable
                      locale="es"
                      :min="filtros.fecha_inicio || fechaMinReporte"
                      :max="fechaMaxReporte"
                    >
                      <v-spacer />
                      <v-btn text @click="ui.modalFin = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="acceptFechaFin">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-col>

            <v-col sm="2" class="text-right" style="margin-top: 21px">
              <v-btn
                small
                outlined
                :loading="loading"
                :disabled="!isFiltroValido"
                color="blueKonect"
                elevation="0"
                @click="fetchConciliacion"
              >
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-alert v-if="totalSalidas > 0" type="info" dense outlined class="mb-4">
            Total de salidas en el periodo: <strong>{{ totalSalidas }}</strong>
          </v-alert>

          <errormsg v-if="error" :text="codeError || 'Ocurrió un error al consultar el servicio'" />

          <v-progress-linear v-if="loading" indeterminate color="pinkKonect" class="mb-2" />

          <v-expansion-panels v-if="grupos.length" accordion multiple>
            <v-expansion-panel
              v-for="(grupo, gIdx) in grupos"
              :key="`grp-${gIdx}-${grupo.nombre_ramal}-${grupo.fecha}`"
            >
              <v-expansion-panel-header>
                <div class="d-flex align-center justify-space-between flex-wrap" style="width: 100%">
                  <span class="font-weight-medium">
                    {{ grupo.nombre_ramal }} · {{ grupo.fecha_label }}
                  </span>
                  <v-chip small color="pinkKonect" text-color="white" class="ml-2">
                    {{ grupo.total_salidas }} salidas
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headers"
                  :items="grupo.recorridos"
                  :items-per-page="25"
                  dense
                  item-key="idrecorrido"
                  class="elevation-0"
                  :footer-props="{
                    itemsPerPageText: 'Elementos por página',
                    itemsPerPageOptions: [10, 25, 50, -1]
                  }"
                >
                  <template #item.comentarios="{ item }">
                    <div class="d-flex align-center">
                      <v-menu
                        v-if="item.comentarios && item.comentarios.length"
                        offset-y
                        max-width="360"
                      >
                        <template #activator="{ on, attrs }">
                          <v-btn icon small color="pinkKonect" v-bind="attrs" v-on="on">
                            <v-badge :content="item.comentarios.length" color="pinkKonect" overlap>
                              <v-icon small>mdi-comment-text-outline</v-icon>
                            </v-badge>
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title class="subtitle-2 py-2 px-3">
                            Comentarios ({{ item.comentarios.length }})
                          </v-card-title>
                          <v-divider />
                          <v-list dense class="py-0">
                            <v-list-item
                              v-for="(c, idx) in item.comentarios"
                              :key="`cmt-${item.idrecorrido}-${idx}`"
                              two-line
                            >
                              <v-list-item-content>
                                <v-list-item-title class="text-body-2">
                                  {{ c.comentario }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-caption">
                                  {{ formatComentarioMeta(c) }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-menu>
                      <v-btn
                        v-if="canComentar"
                        icon
                        small
                        color="primary"
                        aria-label="Agregar comentario"
                        @click="openComentarioDialog(item)"
                      >
                        <v-icon small>mdi-comment-plus-outline</v-icon>
                      </v-btn>
                      <span
                        v-if="!item.comentarios || !item.comentarios.length"
                        class="grey--text text--lighten-1 ml-1"
                      >
                        -
                      </span>
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <p v-else-if="!loading && consultado" class="text-center grey--text mt-6">
            No hay información para los filtros seleccionados.
          </p>
        </v-card-text>
      </v-card>

      <v-dialog v-model="ui.modalComentario" max-width="480" persistent>
        <v-card>
          <v-card-title class="subtitle-1">Agregar comentario</v-card-title>
          <v-card-subtitle v-if="comentarioTarget">
            Folio {{ comentarioTarget.folio || '-' }} · {{ comentarioTarget.operador || 'Sin operador' }}
          </v-card-subtitle>
          <v-card-text>
            <v-textarea
              v-model="comentarioTexto"
              label="Comentario"
              rows="3"
              counter="2000"
              maxlength="2000"
              outlined
              dense
              hide-details="auto"
              :disabled="savingComentario"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text :disabled="savingComentario" @click="closeComentarioDialog">Cancelar</v-btn>
            <v-btn
              color="pinkKonect"
              dark
              :loading="savingComentario"
              :disabled="!comentarioTexto.trim()"
              @click="guardarComentario"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment-timezone'
import downloadjs from 'downloadjs'
import services from '@/utils/services'
import { errormsg } from '@/components'

const FECHA_MIN = '2026-05-01'

function buildConciliacionDefaultFechas() {
  const min = moment(FECHA_MIN, 'YYYY-MM-DD')
  const today = moment().startOf('day')
  if (today.isBefore(min, 'day')) {
    const d = min.format('YYYY-MM-DD')
    return { fecha_inicio: d, fecha_fin: d }
  }
  return {
    fecha_inicio: moment.max(min, today.clone().subtract(6, 'days')).format('YYYY-MM-DD'),
    fecha_fin: today.format('YYYY-MM-DD')
  }
}

const FECHA_DEFAULTS = buildConciliacionDefaultFechas()
const PERM_LECTURA = 'CK_REPORTE_RR_CONCILIACION_LECTURA'
const PERM_COMENTARIO = 'CK_REPORTE_RR_CONCILIACION_COMENTARIO_ESCRITURA'

export default {
  name: 'ConciliacionRegioRuta',
  components: { errormsg },

  data: () => ({
    loading: false,
    loadingExport: false,
    loadingPdf: false,
    loadingClients: false,
    loadingRamales: false,
    savingComentario: false,
    error: false,
    codeError: '',
    consultado: false,
    filtros: {
      fecha_inicio: FECHA_DEFAULTS.fecha_inicio,
      fecha_fin: FECHA_DEFAULTS.fecha_fin
    },
    selectedClienteId: null,
    clientItem: [],
    selectedRamalIds: [],
    ramalItems: [],
    grupos: [],
    totalSalidas: 0,
    permisos: [],
    ui: {
      modalIni: false,
      modalFin: false,
      tmpIni: null,
      tmpFin: null,
      modalComentario: false
    },
    comentarioTarget: null,
    comentarioTexto: '',
    headers: [
      { text: 'Folio', value: 'folio', align: 'start' },
      { text: 'No. Económico', value: 'no_economico', align: 'start' },
      { text: 'Turno', value: 'turno', align: 'end' },
      { text: 'Vuelta', value: 'vuelta', align: 'end' },
      { text: 'Nómina', value: 'num_nomina', align: 'start' },
      { text: 'Operador', value: 'operador', align: 'start' },
      { text: 'Inicio', value: 'punto_inicio', align: 'start' },
      { text: 'Salida', value: 'salida', align: 'start' },
      { text: 'Llegada', value: 'llegada', align: 'start' },
      { text: 'Fin', value: 'punto_fin', align: 'start' },
      { text: 'Comentarios', value: 'comentarios', align: 'center', sortable: false }
    ]
  }),

  computed: {
    fechaMinReporte() {
      return FECHA_MIN
    },
    fechaMaxReporte() {
      return new Date().toISOString().slice(0, 10)
    },
    idclienteEff() {
      const ui = Number(this.selectedClienteId)
      return Number.isFinite(ui) && ui > 0 ? ui : NaN
    },
    isFiltroValido() {
      const { fecha_inicio, fecha_fin } = this.filtros
      const fechasOk = !!fecha_inicio && !!fecha_fin && String(fecha_inicio) <= String(fecha_fin)
      return fechasOk && Number.isFinite(this.idclienteEff)
    },
    canComentar() {
      return this.hasPerm(PERM_COMENTARIO)
    }
  },

  watch: {
    selectedClienteId() {
      this.selectedRamalIds = []
      this.ramalItems = []
      this.grupos = []
      this.totalSalidas = 0
      if (Number.isFinite(this.idclienteEff)) {
        this.loadRamales()
      }
    },

    'ui.modalIni'(open) {
      if (open) this.ui.tmpIni = this.filtros.fecha_inicio
    },

    'ui.modalFin'(open) {
      if (open) this.ui.tmpFin = this.filtros.fecha_fin
    }
  },

  async created() {
    this.permisos = this.$session.get('permisos') || []
    await this.loadClients()
    await this.applyRouteQuery()
  },

  methods: {
    formatFechaDisplay(iso) {
      if (!iso) return ''
      const m = moment(String(iso).slice(0, 10), 'YYYY-MM-DD', true)
      return m.isValid() ? m.format('DD/MM/YYYY') : String(iso)
    },

    acceptFechaInicio() {
      const picked = this.ui.tmpIni
      if (!picked) {
        this.ui.modalIni = false
        return
      }
      this.filtros.fecha_inicio = picked
      if (!this.filtros.fecha_fin || String(picked) > String(this.filtros.fecha_fin)) {
        this.filtros.fecha_fin = picked
        this.ui.tmpFin = picked
      }
      this.$refs.dialogIni.save(picked)
    },

    acceptFechaFin() {
      const picked = this.ui.tmpFin
      if (!picked) {
        this.ui.modalFin = false
        return
      }
      this.filtros.fecha_fin = picked
      if (!this.filtros.fecha_inicio || String(picked) < String(this.filtros.fecha_inicio)) {
        this.filtros.fecha_inicio = picked
        this.ui.tmpIni = picked
      }
      this.$refs.dialogFin.save(picked)
    },

    hasPerm(permiso) {
      const per = this.permisos || []
      return Array.isArray(per) && per.includes(permiso)
    },

    async applyRouteQuery() {
      const q = this.$route.query || {}
      if (q.fecha_inicio) this.filtros.fecha_inicio = String(q.fecha_inicio)
      if (q.fecha_fin) this.filtros.fecha_fin = String(q.fecha_fin)

      const idcliente = Number(q.idcliente)
      if (Number.isFinite(idcliente) && idcliente > 0) {
        this.selectedClienteId = idcliente
        await this.loadRamales()
        if (q.idramal) {
          const ids = String(q.idramal)
            .split(',')
            .map((x) => Number(String(x).trim()))
            .filter((n) => Number.isFinite(n) && n > 0)
          if (ids.length) this.selectedRamalIds = ids
        }
      }

      if (String(q.consultar) === '1' && this.isFiltroValido) {
        await this.fetchConciliacion()
      }
    },

    formatComentarioMeta(c) {
      const autor = (c && c.autor_nombre) ? c.autor_nombre : 'Equipo Konect'
      let fecha = ''
      if (c && c.fecha_creacion) {
        const d = new Date(c.fecha_creacion)
        if (!Number.isNaN(d.getTime())) {
          fecha = d.toLocaleString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })
        }
      }
      return fecha ? `${autor} · ${fecha}` : autor
    },

    async loadClients() {
      this.loadingClients = true
      try {
        const res = await services.ws('get', 'clients')
        const arr = Array.isArray(res?.data) ? res.data : []
        this.clientItem = arr
          .map((c) => ({
            text: c.nombre_comercial,
            value: Number(c.idcliente)
          }))
          .filter((o) => Number.isFinite(o.value) && o.value > 0)
      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'message', 'No se pudieron cargar los clientes')
      } finally {
        this.loadingClients = false
      }
    },

    async loadRamales() {
      const idclienteNum = this.idclienteEff
      if (!Number.isFinite(idclienteNum)) return
      this.loadingRamales = true
      try {
        const baseUrl = _.get(services, 'routes.listRam', null)
        const resp = baseUrl
          ? await this.axios.get(`${baseUrl}${idclienteNum}`)
          : await services.ws('get', `listRam/${idclienteNum}`)
        const data = Array.isArray(resp?.data)
          ? resp.data
          : Array.isArray(resp?.data?.data)
            ? resp.data.data
            : []
        this.ramalItems = (data || [])
          .map((r) => ({
            text: r.nombre_ramal || r.nombre || `Ramal ${r.idramal ?? ''}`,
            value: Number(r.idramal ?? r.id_ramal ?? r.id) || null
          }))
          .filter((x) => Number.isFinite(x.value))
          .sort((a, b) => a.text.localeCompare(b.text, 'es'))
      } catch (e) {
        this.ramalItems = []
        this.error = true
        this.codeError = _.get(e, 'response.data.message', 'No se pudieron cargar los ramales')
      } finally {
        this.loadingRamales = false
      }
    },

    async fetchConciliacion() {
      if (!this.isFiltroValido) return
      this.loading = true
      this.error = false
      this.consultado = true
      try {
        const payload = {
          idcliente: this.idclienteEff,
          fecha_inicio: this.filtros.fecha_inicio,
          fecha_fin: this.filtros.fecha_fin,
          idramal:
            Array.isArray(this.selectedRamalIds) && this.selectedRamalIds.length > 0
              ? this.selectedRamalIds
              : []
        }
        const resp = await services.ws('post', 'repRegRtConciliacion', payload)
        if (!resp?.ok) {
          throw new Error(resp?.message || 'Error al consultar conciliación')
        }
        const data = resp.data || {}
        this.grupos = Array.isArray(data.grupos) ? data.grupos : []
        this.totalSalidas = Number(data.total_salidas) || 0
      } catch (e) {
        this.grupos = []
        this.totalSalidas = 0
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error al consultar'))
      } finally {
        this.loading = false
      }
    },

    openComentarioDialog(item) {
      this.comentarioTarget = item
      this.comentarioTexto = ''
      this.ui.modalComentario = true
    },

    closeComentarioDialog() {
      this.ui.modalComentario = false
      this.comentarioTarget = null
      this.comentarioTexto = ''
    },

    async guardarComentario() {
      if (!this.comentarioTarget || !this.comentarioTexto.trim()) return
      this.savingComentario = true
      try {
        const jwt = this.$session.get('jwt')
        const base = _.get(services, 'routes.runRegRtCommentBase', '')
        const url = `${base}/${this.comentarioTarget.idrecorrido}/comments`
        const resp = await axios.post(
          url,
          { comentario: this.comentarioTexto.trim() },
          { headers: { Authorization: `Bearer ${jwt}` } }
        )
        const nuevo = resp?.data?.data
        if (nuevo) {
          const id = this.comentarioTarget.idrecorrido
          for (const grupo of this.grupos) {
            const row = grupo.recorridos.find((r) => r.idrecorrido === id)
            if (row) {
              if (!Array.isArray(row.comentarios)) row.comentarios = []
              row.comentarios.push({
                comentario: nuevo.comentario,
                fecha_creacion: nuevo.fecha_creacion,
                autor_nombre: 'Tú'
              })
              break
            }
          }
        }
        this.closeComentarioDialog()
      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'response.data.message', 'No se pudo guardar el comentario')
      } finally {
        this.savingComentario = false
      }
    },

    exportarCsv() {
      if (!this.grupos.length) return
      this.loadingExport = true
      try {
        const cols = this.headers.filter((h) => h.value !== 'comentarios')
        const lines = [cols.map((c) => c.text).join(',')]
        for (const grupo of this.grupos) {
          lines.push(`"${grupo.nombre_ramal} · ${grupo.fecha_label} (${grupo.total_salidas} salidas)"`)
          for (const row of grupo.recorridos) {
            const comentariosTxt = Array.isArray(row.comentarios)
              ? row.comentarios.map((c) => c.comentario).join(' | ')
              : ''
            const values = cols.map((c) => {
              const v = row[c.value]
              const raw = v == null ? '' : String(v)
              return `"${raw.replace(/"/g, '""')}"`
            })
            values.push(`"${comentariosTxt.replace(/"/g, '""')}"`)
            lines.push(values.join(','))
          }
        }
        const blob = new Blob(['\ufeff' + lines.join('\n')], { type: 'text/csv;charset=utf-8' })
        const nombre = `conciliacion_regio_${this.filtros.fecha_inicio}_a_${this.filtros.fecha_fin}.csv`
        downloadjs(blob, nombre, 'text/csv')
      } finally {
        this.loadingExport = false
      }
    },

    async exportarPdf() {
      if (!this.grupos.length) return
      this.loadingPdf = true
      try {
        const { jsPDF } = await import(/* webpackChunkName: "jspdf" */ 'jspdf')
        const autoTableModule = await import(/* webpackChunkName: "jspdf-autotable" */ 'jspdf-autotable')
        const autoTable = autoTableModule.default || autoTableModule.autoTable || autoTableModule

        const DIAS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
        const MESES = [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ]
        const fechaLarga = (f) => {
          const m = moment(f, ['YYYY-MM-DD', 'DD/MM/YYYY'])
          if (!m.isValid()) return String(f || '')
          return `${DIAS[m.day()]}, ${m.format('DD')} De ${MESES[m.month()]} De ${m.year()}`
        }
        const fmtHora = (h) => {
          if (!h) return ''
          const mt = String(h).trim().match(/^(\d{1,2}):(\d{2})/)
          return mt ? `${Number(mt[1])}:${mt[2]}` : String(h).trim()
        }
        const comentariosText = (arr) =>
          Array.isArray(arr)
            ? arr.map((c) => (c && c.comentario ? String(c.comentario) : '')).filter(Boolean).join('\n')
            : ''

        const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'letter' })
        const pageW = doc.internal.pageSize.getWidth()
        const pageH = doc.internal.pageSize.getHeight()

        const head = [[
          'Folio', 'No. Económico', 'Turno', 'Vuelta', 'Num Nomina',
          'Operador', 'Inicio', 'Salida', 'Llegada', 'Fin', 'Comentarios'
        ]]
        const columnStyles = {
          0: { halign: 'center', cellWidth: 11 },
          1: { halign: 'center', cellWidth: 18 },
          2: { halign: 'center', cellWidth: 10 },
          3: { halign: 'center', cellWidth: 10 },
          4: { halign: 'center', cellWidth: 15 },
          5: { halign: 'left', cellWidth: 32 },
          6: { halign: 'left', cellWidth: 26 },
          7: { halign: 'center', cellWidth: 12 },
          8: { halign: 'center', cellWidth: 12 },
          9: { halign: 'left', cellWidth: 26 },
          10: { halign: 'left' }
        }

        this.grupos.forEach((grupo, gIdx) => {
          if (gIdx > 0) doc.addPage()
          const tituloRamal = `RUTA ${grupo.nombre_ramal || ''}`.trim()
          const subtitulo = fechaLarga(grupo.fecha)

          const body = (grupo.recorridos || []).map((r) => ([
            r.folio != null ? String(r.folio) : '',
            r.no_economico || '',
            r.turno != null ? String(r.turno) : '',
            r.vuelta != null ? String(r.vuelta) : '',
            r.num_nomina || '',
            r.operador || '',
            r.punto_inicio || '',
            fmtHora(r.salida),
            fmtHora(r.llegada),
            r.punto_fin || '',
            comentariosText(r.comentarios)
          ]))

          autoTable(doc, {
            head,
            body,
            startY: 24,
            margin: { top: 22, left: 8, right: 8 },
            theme: 'grid',
            styles: {
              font: 'helvetica',
              fontSize: 7,
              cellPadding: 1,
              lineColor: [0, 0, 0],
              lineWidth: 0.1,
              valign: 'middle',
              overflow: 'linebreak'
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              lineColor: [0, 0, 0],
              lineWidth: 0.1,
              fontStyle: 'bold',
              halign: 'center',
              fontSize: 7
            },
            columnStyles,
            didDrawPage: () => {
              doc.setFont('helvetica', 'bold')
              doc.setFontSize(12)
              doc.text(tituloRamal, 8, 12)
              doc.setFont('helvetica', 'normal')
              doc.setFontSize(9)
              doc.text(subtitulo, 8, 18)
            }
          })

          const finalY = (doc.lastAutoTable && doc.lastAutoTable.finalY) || 24
          let yTotal = finalY + 6
          if (yTotal > pageH - 14) {
            doc.addPage()
            yTotal = 22
          }
          const totalGrupo = grupo.total_salidas != null
            ? grupo.total_salidas
            : (grupo.recorridos || []).length
          doc.setFont('helvetica', 'bold')
          doc.setFontSize(9)
          doc.text(`Total salidas ${totalGrupo}`, 8, yTotal)
        })

        const totalPages = doc.internal.getNumberOfPages()
        for (let p = 1; p <= totalPages; p++) {
          doc.setPage(p)
          doc.setFont('helvetica', 'normal')
          doc.setFontSize(8)
          doc.text(`-- ${p} of ${totalPages} --`, pageW / 2, pageH - 6, { align: 'center' })
        }

        const stamp = moment().format('YYYYMMDDHHmm')
        const fileName =
          `CONCILIACION_REGIORUTA_${this.filtros.fecha_inicio}_${this.filtros.fecha_fin}_${stamp}.pdf`
        doc.save(fileName)
      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'message', 'No se pudo generar el PDF')
      } finally {
        this.loadingPdf = false
      }
    }
  }
}
</script>
